import {
  CognitoUserPool,
  CognitoUserSession,
} from 'amazon-cognito-identity-js';
import { CognitoIdentityCredentials, config as AWSConfig } from 'aws-sdk';

interface ICognitoConfig {
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
  identityPoolId: string;
}

export default class Cognito {
  private userPool: CognitoUserPool;

  public constructor(config: ICognitoConfig) {
    this.userPool = new CognitoUserPool({
      UserPoolId: config.userPoolId,
      ClientId: config.userPoolWebClientId,
    });
    AWSConfig.region = config.region;
    AWSConfig.credentials = new CognitoIdentityCredentials({
      IdentityPoolId: config.identityPoolId,
    });
  }

  public logout(): void {
    const currentUser = this.userPool.getCurrentUser();
    if (currentUser) {
      currentUser.signOut();
    }
  }

  /**
   * <p>Check whether logged in</p>
   * @return resolve, if the user logged in
   */
  public isAuthenticated(): Promise<CognitoUserSession> {
    const cognitoUser = this.userPool.getCurrentUser();
    if (!cognitoUser) {
      return Promise.reject(null);
    }
    return new Promise((resolve, reject) => {
      cognitoUser.getSession(
        (err: Error | null, session: CognitoUserSession | null) => {
          if (err) {
            reject(err);
          } else if (session && !session.isValid()) {
            reject(session);
          } else if (session) {
            resolve(session);
          }
        }
      );
    });
  }
}
